/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'gh-report-settings-tab-container',
  templateUrl: 'report-settings-tab-container.component.html',
})
export class ReportSettingsTabContainerComponent {

}
